import SystemSettingActionType from 'actions/systemSetting/systemSettingActionType';

const initialState = {
  systemSettings: {},
};

const systemSettingReducer = (state = initialState, { type, payload }) => {
  switch (type) {
  case SystemSettingActionType.SAVE_SYSTEM_SETTINGS: {
    return {
      ...state,
      systemSettings: payload.data,
    };
  }
  case SystemSettingActionType.RESET_SYSTEM_SETTINGS:
    return {
      ...state,
      systemSettings: {},
    };
  default:
    return state;
  }
};

export default systemSettingReducer;
